<template>
	<div class="scrollbar">
		<slot></slot>
	</div>
</template>
<script>
  export default {
    methods: {
      resetScroll() {
        this.$el.scrollTop = 0;
      }
    }
  }
</script>
<style scoped>
	.scrollbar {
		overflow-y: auto;
		height: 100%;
		/*mozilla scrollbar*/
		scrollbar-color: #aeb5c0 #e4e4e4;
		scrollbar-width: thin;
	}

		.scrollbar::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
			background-color: white;
		}

		.scrollbar::-webkit-scrollbar {
			width: 6px;
			height: 6px;
			background-color: white;
		}

		.scrollbar::-webkit-scrollbar-thumb {
			border-radius: 10px;
			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
			background-color: #C0CAD5;
		}
</style>